import { noticeError } from './newrelic';

export default async function getToken(videoApiURL: string, provider: 'MPX' | 'JWP'): Promise<string | null> {
  try {
    const response = await fetch(`${videoApiURL}/graphql`, {
      method: 'POST',
      headers: window.isProduction ? {} : { 'x-client-details': 'qa' },
      body: JSON.stringify({
        query: `{ drmToken(drmProvider: ${provider}) { token expiration } }`,
        variables: {},
      }),
    });
    const { data, errors } = await response.json();

    if (errors?.length || !data?.drmToken) {
      const [error] = errors || [];
      noticeError('Failed to fetch token', { graphql_error: error.message });
      return null;
    }

    return data.drmToken.token;
  } catch (error) {
    console.error(error);
    noticeError('Failed to fetch token', { graphql_error: (error as any)?.message });
  }
  return null;
}
